const folder = {
  state: {
    folderId: 1,
    folderName: '',
    folders: []
  },

  mutations: {
    SET_FOLDER_ID: (state, folderId) => {
      state.folderId = folderId;
    },
    SET_FOLDER_NAME: (state, folderName) => {
      state.folderName = folderName;
    },
    SET_FOLDERS: (state, folders) => {
      state.folders = folders;
    }
  },

  actions: {

  }
};

export default folder;



// WEBPACK FOOTER //
// ./src/store/modules/folder.js